import type { SVGProps } from 'react';
const SvgExpandedSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    fontSize="1rem"
    {...props}
  >
    <path
      stroke="#AAA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M18.308 12.5v-5c0-4.166-1.666-5.833-5.833-5.833h-5c-4.167 0-5.833 1.667-5.833 5.833v5c0 4.167 1.666 5.834 5.833 5.834h5c4.167 0 5.833-1.667 5.833-5.834M12.475 1.667v16.667"
    />
    <path
      stroke="#AAA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M6.642 7.866 8.775 10l-2.133 2.133"
    />
  </svg>
);
export default SvgExpandedSidebar;
